import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  position: relative;\n  padding: 8px;\n  padding-right: 40px;\n  background: ', ';\n  color: ', ';\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.3;\n'], ['\n  ', ';\n  position: relative;\n  padding: 8px;\n  padding-right: 40px;\n  background: ', ';\n  color: ', ';\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.3;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  a,\n  button {\n    display: inline;\n    padding: 0;\n    border: none;\n    background: none;\n    color: inherit;\n    font: inherit;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n'], ['\n  a,\n  button {\n    display: inline;\n    padding: 0;\n    border: none;\n    background: none;\n    color: inherit;\n    font: inherit;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0;\n  &:not(:last-child) {\n    margin-bottom: 6px;\n  }\n'], ['\n  margin: 0;\n  &:not(:last-child) {\n    margin-bottom: 6px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 8px;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n'], ['\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 8px;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n']);

import React, { PureComponent } from 'react';
import styled from 'react-emotion';
import fontStyles from './font-styles';
var Root = /*#__PURE__*/styled('div', {
  target: 'exqsvii0',
  label: 'Root'
})(_templateObject, fontStyles, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
});
var Content = /*#__PURE__*/styled('div', {
  target: 'exqsvii1',
  label: 'Content'
})(_templateObject2);
var P = /*#__PURE__*/styled('p', {
  target: 'exqsvii2',
  label: 'P'
})(_templateObject3);
var CloseButton = /*#__PURE__*/styled('button', {
  target: 'exqsvii3',
  label: 'CloseButton'
})(_templateObject4);

var Banner = function (_PureComponent) {
  _inherits(Banner, _PureComponent);

  function Banner() {
    _classCallCheck(this, Banner);

    return _possibleConstructorReturn(this, (Banner.__proto__ || _Object$getPrototypeOf(Banner)).apply(this, arguments));
  }

  _createClass(Banner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          innerRef = _props.innerRef,
          onAccept = _props.onAccept,
          onChangePreferences = _props.onChangePreferences,
          content = _props.content,
          subContent = _props.subContent,
          backgroundColor = _props.backgroundColor,
          textColor = _props.textColor;
      return React.createElement(Root, {
        innerRef: innerRef,
        backgroundColor: backgroundColor,
        textColor: textColor
      }, React.createElement(Content, null, React.createElement(P, null, content), React.createElement(P, null, React.createElement('button', {
        type: 'button',
        onClick: onChangePreferences
      }, subContent))), React.createElement(CloseButton, {
        type: 'button',
        title: 'Accept policy',
        'aria-label': 'Accept policy',
        onClick: onAccept
      }, "\u2715"));
    }
  }]);

  return Banner;
}(PureComponent);

Banner.displayName = 'Banner';
export default Banner;